<template>
  <GenericTooltip
    theme="white"
    :width="190"
    @keydown.enter.prevent="goToLegiWork(amendment.doc_ref)"
  >
    <template #trigger>
      <div class="title title-medium-semibold">
        {{ amendment.legi_title }}
      </div>
    </template>
    <template #text>
      <RouterLink
        :to="`/legislatives/${amendment.doc_ref}/expose-motifs`"
        class="to-legidoc typo-body-regular"
      >
        <i class="fa-kit fa-dossierlegi"></i>
        <span class="tooltip-link-label">Voir le dossier législatif</span>
      </RouterLink>
    </template>
  </GenericTooltip>

  <div class="statuses interface-small-regular">
    <AmendmentStatusTag :status="amendment.status" v-focus tabindex="0" />
    <GenericTag
      v-if="shouldDisplayLongStatus"
      background-color="var(--clr-tag-status)"
      color="var(--clr-n8)"
      >{{ amendment.status_long }}</GenericTag
    >
  </div>

  <div class="author-and-infos-wrapper">
    <div class="author">
      <PersonSmallCard :author="amendment.author" />
      <div v-if="amendment.nb_cosignataires" class="title-small-regular">
        + {{ amendment.nb_cosignataires }} cosignataire{{
          amendment.nb_cosignataires > 1 ? "s" : ""
        }}
      </div>
    </div>
    <ul class="infos title-medium-regular">
      <li class="title-medium-semibold">Amendment n° {{ amendment.number }}</li>
      <li>{{ amendment.title }}</li>
      <li>
        <i class="fa-solid fa-location-dot"></i>
        {{ getInstitutionsNames(amendment.institution) }}
        ({{ amendment.examined_by }})
      </li>
    </ul>
  </div>

  <div v-if="amendment.matched_words && amendment.matched_words.length > 0">
    <span class="matched-title title-medium-regular"
      >Mot{{ amendment.matched_words.length > 1 ? "s" : "" }} matché{{
        amendment.matched_words.length > 1 ? "s" : ""
      }}
      :
    </span>
    <!-- eslint-disable-next-line vue/no-v-html-->
    <span v-html="listOfWords" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRouter } from "vue-router";
import GenericTooltip from "@follaw-fr/components/reusable/atoms/GenericTooltip.vue";
import AmendmentStatusTag from "@follaw-fr/components/amendments/atoms/AmendmentStatusTag.vue";
import PersonSmallCard from "@follaw-fr/components/legi-work/atoms/PersonSmallCard.vue";
import GenericTag from "@follaw-fr/components/reusable/atoms/GenericTag.vue";
import { getInstitutionsNames } from "@/follaw-fr/utils/institutions.utils";

const props = defineProps({
  amendment: {
    type: Object,
    required: true,
  },
});

const router = useRouter();

const listOfWords = computed(() =>
  props.amendment.matched_words?.filter((_, idx) => idx < 10).join(", ")
);

const shouldDisplayLongStatus = computed(
  () =>
    props.amendment.status_long &&
    props.amendment.status_long !== props.amendment.status &&
    props.amendment.institution !== "Sénat"
);

// Zoom on one LegiWork
const goToLegiWork = (doc_ref) => {
  router.push(`/legislatives/${doc_ref}/expose-motifs`);
};
</script>
<style lang="scss" scoped>
.body {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.title:hover,
.title:focus {
  color: var(--clr-s7);
}

.tooltip-link-label {
  margin-left: 4px;
}

.to-legidoc:focus-visible {
  box-shadow: 0 0 5px 2px #a802e3;
  outline: 2px solid #a802e3;
}

.statuses {
  display: flex;
  align-items: center;
  gap: 4px;

  .tag {
    text-transform: capitalize;
  }
}

.author-and-infos-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;

  .author {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border-right: 1px solid var(--clr-s3);

    .author-infos {
      display: flex;
      flex-direction: column;
      gap: 4px;

      .name {
        text-transform: capitalize;
      }
    }
  }

  .infos {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 0;
    padding: 0;
    color: var(--clr-s7);
    list-style-type: none;
  }
}

.matched-title {
  color: var(--clr-s7);
}
</style>
